<template>
  <div class="modal-backdrop" v-if="visible">
    <div class="modal-dialog" :class="type">
      <div class="modal-content">
        <div class="modal-top-section">
          <br />
          <img v-if="type == 'success'" src="@/assets/images/right.png" />
          <img v-if="type == 'warning'" src="@/assets/images/seru.png" />
          <h2 class="modal-title-header">{{ title }}</h2>
          <p class="modal-description-text">{{ titledescription }}</p>
        </div>

      
        <div class="modal-bottom-section">
          <p
            v-if="showNote"
            class="modal-note-title"
          >
            Note
          </p>
          <p
            v-if="showNote"
            class="modal-note-message"
          >
            {{ message }}
          </p>
          <button 
            v-if="showConfirm" 
            :class="[
              'modal-btn',
              type === 'success' ? 'btn-outline-success-modal' : 'btn-outline-warning',
              type === 'warning' && !showCancel ? 'btn-primary-modal-confirm' : ''
            ]" 
            @click="$emit('confirm')"
          >
            {{ confirmMessageButton }}
          </button>
          
          <button
            v-if="showCancel"
            class="modal-btn btn-primary-modal"
            @click="$emit('cancel')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    message: String,
    // Note: Removed duplicate 'titledescription' prop
    titledescription: String, 
    showNote: Boolean,
    showConfirm: Boolean,
    confirmMessageButton: String,
    type: {
      type: String,
      default: "success",
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
/*
|--------------------------------------------------------------------------
| BASE STYLES (Default / Desktop)
|--------------------------------------------------------------------------
| Applying styles that are common or act as a desktop/default baseline.
*/
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-dialog {
  max-width: 450px; /* Default Desktop Max Width */
  width: 450px;
  border-radius: 81px 8px 8px 8px;
  overflow: hidden;
  background-color: transparent;
}

.modal-content {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 81px 8px 8px 8px;
  overflow: hidden;
}

.modal-top-section img {
  width: 140px; /* Default Icon Size */
  height: auto;
}

.modal-dialog.success .modal-top-section {
  padding: 20px 60px; /* Default Padding */
  background: linear-gradient(180deg, #bcefdd 0%, #a2cee7 100%);
  border-radius: 81px 8px 81px 0;
  text-align: center;
}

.modal-dialog.warning .modal-top-section {
  padding: 20px 60px; /* Default Padding */
  background: linear-gradient(180deg, #ffae2c 0%, #ffd188 100%);
  border-radius: 81px 8px 81px 0;
  text-align: center;
}

.modal-title-header {
  color: #009a78; /* This was white in your original CSS, but should be green for success */
  font-size: 21px !important; /* Default Desktop Title Size */
  font-weight: 600;
  margin-top: 13px;
}

/* Ensure title color is white for warning, based on the provided CSS */
.modal-dialog.warning .modal-title-header {
    color: white;
}

.modal-description-text {
  color: white;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
}

.modal-bottom-section {
  padding: 30px;
  background: white;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.modal-note-title {
  text-align: center;
  color: #ffae2c;
  font-size: 16px;
  font-weight: 600;
}

.modal-note-message {
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #a9a9a9;
}

/* BUTTON BASE STYLES */
.modal-btn {
  width: 100%; /* Default to full width of bottom section */
  border: none;
  padding: 15px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
}

.btn-primary-modal { /* Cancel button (orange) */
  background-color: #ffae2c;
  color: white;
}

.btn-primary-modal-confirm { /* Used when warning has NO cancel button, takes up full width */
  background-color: #ffae2c;
  color: white;
}

.btn-outline-warning { /* Warning confirm button (white/outlined) */
  border: 1px solid #ffae2c;
  color: #ffae2c;
  background: transparent;
}

.btn-outline-warning:hover {
  background-color: #ffae2c;
  color: white;
}

.btn-outline-success-modal { /* Success confirm button (green) */
  border: 1px solid #009a78;
  color: #ffffff;
  background: #009a78;
}

/*
|--------------------------------------------------------------------------
| MOBILE ADJUSTMENTS (max-width: 424px)
|--------------------------------------------------------------------------
*/
@media (max-width: 424px) { 
  .modal-dialog {
    max-width: 87% !important; /* From your swal-mobile-width */
    width: 87% !important;
  }
  
  .modal-dialog.success .modal-top-section,
  .modal-dialog.warning .modal-top-section {
    padding: 10px 30px !important; /* From your swal2-content mobile styles */
    height: auto !important; /* Allows height to adjust */
  }

  .modal-top-section img {
    width: 120px; /* Icon size adjustment */
  }
  
  .modal-top-section h2 {
      font-size: 14px !important; /* Header size adjustment */
  }
  
  .modal-top-section p {
      font-size: 18px !important; /* Description text size adjustment */
  }

  .modal-bottom-section {
    /* If the modal has two buttons, they might be stacked, 
       but if you want them side-by-side: */
    /* flex-direction: row; 
       justify-content: space-between; */
  }

  .modal-btn {
    /* max-width is applied to swal buttons when there's a cancel button, 
       here we keep them full width for better mobile UX */
    max-width: none; 
    font-size: 16px;
  }
}

/*
|--------------------------------------------------------------------------
| DESKTOP/TABLET (min-width: 768px)
|--------------------------------------------------------------------------
*/
@media (min-width: 768px) {
    .modal-top-section h2 {
        font-size: 18px !important;
    }
}


/*
|--------------------------------------------------------------------------
| ULTRA-WIDE / 2560px BREAKPOINT
|--------------------------------------------------------------------------
*/
@media (min-width: 2560px) {
  .modal-dialog {
    max-width: 580px !important; /* Max Width */
    width: 90% !important; /* Width */
    border-radius: 118px 12px 12px 12px !important; /* Border Radius */
  }

  .modal-top-section {
    height: 370px !important; /* Height for content */
    padding: 30px 80px !important; /* Padding */
    border-radius: 118px 12px 118px 0px; /* Top Section Border Radius */
  }

  .modal-top-section h2 {
    font-size: 24px !important;
  }
  
  
  .modal-top-section img {
    width: 170px !important; /* Icon size */
  }

  .modal-title-header {
    font-size: 26px !important; /* Header font size */
    padding-top: 20px !important; /* Header top padding */
  }
  
  .modal-dialog.success .modal-title-header {
      padding-bottom: 22px !important; /* Success specific padding */
  }

  .modal-description-text {
    font-size: 22px !important; /* Description text size */
    line-height: 28px !important;
  }

  .modal-note-title {
    font-size: 22px !important; /* Note title size */
    margin-bottom: 24px;
  }

  .modal-note-message {
    font-size: 20px !important; /* Note message size */
    line-height: 28px !important;
  }
  
  .modal-btn {
    width: 460px !important; /* Button width */
    height: 75px !important; /* Button height */
    font-size: 20px; /* Button font size */
    border-radius: 12px !important; /* Button border radius */
    /* Center the buttons since they are now a fixed width */
    margin-left: auto;
    margin-right: auto;
  }
}

/*
|--------------------------------------------------------------------------
| ULTRA-ULTRA-WIDE / 3840px (4K) BREAKPOINT
|--------------------------------------------------------------------------
*/
@media (min-width: 3840px) {
  .modal-dialog {
    max-width: 900px !important; /* Max Width */
    width: 90% !important; /* Width */
    border-radius: 188px 18px 18px 18px !important; /* Border Radius */
  }

  .modal-top-section {
    height: 585px !important; /* Height for content */
    padding: 60px 100px !important; /* Padding */
    border-radius: 188px 12px 188px 0px; /* Top Section Border Radius */
  }

   .modal-top-section h2 {
    font-size: 38px !important;
  }
  
  /* Success top section needs full height adjustment */
  .modal-dialog.success .modal-top-section {
      height: 100% !important; 
  }

  .modal-top-section img {
    width: 280px !important; /* Icon size */
  }

  .modal-title-header {
    font-size: 38px !important; /* Header font size */
    padding-top: 20px !important; /* Header top padding */
  }

  .modal-dialog.success .modal-title-header {
      padding-bottom: 40px !important; /* Success specific padding */
  }

  .modal-description-text {
    font-size: 44px !important; /* Description text size */
    line-height: 40px !important;
  }
  
  .modal-note-title {
    font-size: 32px !important; /* Note title size */
    margin-bottom: 44px;
  }

  .modal-note-message {
    font-size: 30px !important; /* Note message size */
    line-height: 48px !important;
  }

  .modal-btn {
    width: 700px !important; /* Button width */
    height: 116px !important; /* Button height */
    font-size: 32px; /* Button font size */
    border-radius: 12px !important; /* Button border radius */
  }
}
</style>